
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PositionItemProps } from ".";
import { loading, create } from "store/position";

interface ApiPositionCreateInputProps extends Omit<PositionItemProps, "id"> {
}

type ApiPositionCreateOutputProps = OutputBaseProps<{ item: PositionItemProps; }, ApiPositionCreateInputProps>;

export const apiPositionCreate = async (data: ApiPositionCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiPositionCreateOutputProps>("/api/position/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};